import { render } from "./UserChatsView.vue?vue&type=template&id=e79a2c04&scoped=true&ts=true"
import script from "./UserChatsView.vue?vue&type=script&lang=ts"
export * from "./UserChatsView.vue?vue&type=script&lang=ts"

import "./UserChatsView.vue?vue&type=style&index=0&id=e79a2c04&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79a2c04"]])

export default __exports__